module.exports = __webpack_public_path__ + "img/icon_4.793c511f.svg";